<template>
  <div id="trainer-designation">
    <h4 class="sub-title">Trainer Designation</h4>
    <div id="designation" class="dropdown">
      <label for="designation">Type of Trainer:</label>
      <br />
      <b-form-select name="designation" v-model="designation" required>
        <option disabled value>Select a Trainer Type</option>
        <option value="Regular">Regular</option>
        <option value="Advanced">Advanced</option>
        <option value="Coordinator">Coordinator</option>
      </b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerDesignation',
  props: [],
  computed: {
    designation: {
      get() {
        return this.$store.state.trainers.trainer.designation;
      },
      set(val) {
        this.$store.commit('trainers/designation', val);
      },
    },
  },
};
</script>
